module.exports = __webpack_public_path__ + "static/frantisek-943e744f0981eb89f501a58419db7d68.png";